import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { c2bTradeApiUrl } from "../constants/url-constants";
const BASE_API_URL = `${c2bTradeApiUrl()}/api`;
export default createScopedApi(BASE_API_URL, axiosInstance);
